export const NavbarText = {
  key1: 'Producten',
  key2: 'Toepassingen',
  key3: 'Prijs',
  key4: 'Ontwikkelaars',
  key5: 'Help & Guides',
  key6: 'Login',
  key7: 'Contact'
}

export default NavbarText;



// WEBPACK FOOTER //
// ./src/input-text/nl/navbar.js